module.exports = __webpack_public_path__ + "assets/3a7a8f2761a4c38879326e33385709ec.png";